import { VersionRepository } from "@/domain/repository/version-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { VersionInfo } from "../info/version-info";
import { VersionInfoMapper } from "../mapper/version-info-mapper";
import { VersionSource } from "../source/version-source";
import { safeMapToEntity } from "./safe-map-to-entity";

export class VersionRepositoryImpl implements VersionRepository {
  constructor(private readonly versionSource: VersionSource) {}

  async fetchVersion(): Promise<SATResult<VersionInfo, SATError>> {
    const result = await this.versionSource.fetchVersion();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      VersionInfoMapper.toInfo,
      "AuthRepositoryImpl::fetchVersion"
    );
  }
}
